import React, { useState, useEffect } from 'react';
import './RulesBook.css';

// Complete JULEGOLF 10.0 rule set
const rules = [
  // Kapitel 1 - Generelle regler
  { 
    title: 'Kapitel 1 - Generelle regler', 
    description: '§1 - Formål\nJulegolf – LOLDISC 10.0 er en modificeret version af discgolf, hvor målet er at bruge færrest kast efter 18 huller.\n\n§2 - Startpoint\nVindere af tidligere udgaver starter med handicap:\nAntal tidligere sejre = antal ekstra kast (pluspoint) ved start.\n\n§3 - Tee-steder\nSpillet spilles som udgangspunkt fra gul tee.\n\n§4 - Par-golf for bundspillere\nDe to dårligst placerede spillere i klassementet spiller pargolf. Ved pointlighed afgøres det med sten-saks-papir. Vinderen spiller pargolf.\n\n§5 - "Your just too good"-reglen\nHvis en spiller laver birdie, eagle eller ace, skal vedkommende gå 10 skridt baglæns på næste hul.' 
  },
  
  // Kapitel 2 - Spells (del 1)
  { 
    title: 'Kapitel 2 - Spells (1/3)', 
    description: '§6 - Typer af spells\nDer findes tre typer:\n• Lortespell\n• Superlortespell\n• Masterlortespell\n\n§7 - Brug af spells\nSpells kastes i umiddelbar forbindelse med en spillers tur (spilleren skal stå ved sin disc).\nFor tidligt kastede spells bortfalder.\nEffekten træder i kraft øjeblikkeligt.\nSpells er hemmelige og personlige – de må ikke vises til andre.\n\n§8 - Kombination og effekt\nFlere spells kan kastes på samme spiller, også af forskellige spillere.\nNår en spiller kaster en disc påvirket af lorte- eller superlortespell, opstår et skjold, som beskytter mod næste spell.\nSkjoldet forsvinder efter ét kast eller ved hullets afslutning.\nSpells må gerne kastes på én selv, men udløser i så fald ikke et skjold.' 
  },
  
  // Kapitel 2 - Spells (del 2)
  { 
    title: 'Kapitel 2 - Spells (2/3)', 
    description: '§9 - Startspells\nAlle spillere starter med én spell.\nDe 3 med færrest julegolfsejre starter med en superlortespell.\nDe øvrige 3 starter med en lortespell.\n\n§10 - Nye spells efter boss-huller\nEfter hvert boss-hul:\nTop 3 modtager en superlortespell\nBund 3 modtager en lortespell\n\n§11 - Spell-grænse\nEn spiller må maksimalt bære 2 spells.\nModtages en tredje, kastes én af spillerens egne spells på vedkommende efter lodtrækning foretaget af den førende spiller.\n\n§12 - Automatiske spells ved dårlige resultater\nAlle spillere, der laver dobbeltbogey eller værre, modtager en superlortespell.\nHvis ingen laver dobbeltbogey eller værre:\nDårligste spiller på hullet får en superlortespell.\nVed pointlighed gives den til spilleren lavest i klassementet. Ved fortsat lighed: sten-saks-papir.\nNæstdårligste får en lortespell. Samme afgørelsesmetode ved lighed.' 
  },
  
  // Kapitel 2 - Spells (del 3)
  { 
    title: 'Kapitel 2 - Spells (3/3)', 
    description: '§13 - Belønning ved gode resultater\nBirdie: +1 lortespell\nEagle/Ace: +1 superlortespell\n\n§14 - Out of Bounds (OB)\nOB-kast spilles videre fra det sted, disc\'en ligger.\nSpilleren modtager en superlortespell med øjeblikkelig virkning.\nSkjold beskytter ikke mod denne spell.\nHvis disc\'en er våd, må man gå ind på land.' 
  },
  
  // Kapitel 3 - Boss-huller
  { 
    title: 'Kapitel 3 - Boss-huller', 
    description: '§15 - Specielle huller\nPå hul 3, 7 og 18 må der ikke kastes spells.\nDisse er Boss-baner og skal gennemføres individuelt og på særskilt vis.\n\nBoss-eksempler:\nHul 1: Fang halerne – kast fra bænk med mindst én fod på disc. Kun fødder må røre jorden.\n\nHul 6: Boomerang – få disc\'en til at rulle tilbage og gribe den.\n\nHul 13: Gå med disc på hovedet – kun røre disc, når den er på jorden.' 
  },
  
  // Kapitel 4 - Mini-discipliner
  { 
    title: 'Kapitel 4 - Mini-discipliner', 
    description: '§16 - Discgolf skills-konkurrence\nAfholdes på hul 4, hul 6 og hul 13.\n\nPræmier:\n1. plads: Masterlortespell\n2. plads: Superlortespell\n3. plads: Lortespell' 
  },
  
  // Kapitel 5 - Særlige regler
  { 
    title: 'Kapitel 5 - Særlige regler', 
    description: '§17 - Særlige huller og regler\nHul 10: Drive med fodbold.\nHul 15: Alle starter med en superlortespell.\n\n§18 - Spell-virkning\nSpells gælder kun for den spiller, de kastes på, medmindre de har en par-effekt.' 
  }
];

// 2. Helper to get rule page index (spread) from rule index (for navigation)
const RULES_START_SPREAD = 1; // 0: cover+index, 1+: rules
const getRuleSpread = (ruleIdx) => RULES_START_SPREAD + ruleIdx; // One rule per spread now

// Responsive book dimensions for closed book (cover)
const getClosedBookDimensions = (windowWidth) => {
  if (windowWidth <= 480) {
    return { width: 300, height: 420 }; // Mobile small
  } else if (windowWidth <= 768) {
    return { width: 400, height: 560 }; // Mobile large
  } else {
    return { width: 500, height: 700 }; // Desktop - original proportions
  }
};

// Responsive book dimensions for open book
const getBookDimensions = (windowWidth) => {
  if (windowWidth <= 480) {
    return { width: 300, height: 420 }; // Mobile small
  } else if (windowWidth <= 768) {
    return { width: 400, height: 560 }; // Mobile large
  } else {
    return { width: 800, height: 700 }; // Desktop - wider but not as tall
  }
};

function RulesBook() {
  // All hooks and state must be inside the component
  const [open, setOpen] = useState(false);
  const [spread, setSpread] = useState(0); // spread index: 0 = first, 1 = next, ...
  const [flipping, setFlipping] = useState(''); // '' | 'forward' | 'backward'
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [pendingJump, setPendingJump] = useState(null);
  const [showChapterOverview, setShowChapterOverview] = useState(false);
  const [showExitButton, setShowExitButton] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle scroll to show/hide exit button on mobile
  useEffect(() => {
    if (windowWidth <= 768 && open) {
      const handleScroll = () => {
        const scrollY = window.scrollY;
        setShowExitButton(scrollY > 50);
      };
      
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [windowWidth, open]);

  // Responsive title styling
  const getTitleStyle = () => {
    if (windowWidth <= 480) {
      return { fontSize: '1.4rem', fontWeight: 'bold', marginBottom: 12 };
    } else if (windowWidth <= 768) {
      return { fontSize: '1.8rem', fontWeight: 'bold', marginBottom: 16 };
    } else {
      return { fontSize: '2.4rem', fontWeight: 'bold', marginBottom: 24 };
    }
  };

  const handleOpen = () => {
    setOpen(true);
    setShowChapterOverview(true);
    // Force landscape mode on mobile
    if (windowWidth <= 768) {
      if (window.screen.orientation && window.screen.orientation.lock) {
        window.screen.orientation.lock('landscape').catch(() => {
          // Fallback if orientation lock fails
        });
      }
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setOpen(false);
    setSpread(0);
    setShowChapterOverview(false);
    // Unlock orientation on mobile
    if (windowWidth <= 768) {
      if (window.screen.orientation && window.screen.orientation.unlock) {
        window.screen.orientation.unlock();
      }
    }
  };



  const handleFlip = (dir) => {
    if (flipping) return;
    if (dir === 'forward' && spread < maxSpread) {
      setFlipping('forward');
      setTimeout(() => {
        setSpread((s) => s + 1);
        setFlipping('');
      }, 700);
    } else if (dir === 'backward' && spread > 0) {
      setFlipping('backward');
      setTimeout(() => {
        setSpread((s) => s - 1);
        setFlipping('');
      }, 700);
    }
  };

  // Helper function to split text into two parts by paragraphs
  const splitText = (text, ruleIndex) => {
    const paragraphs = text.split('\n\n');
    
    // Special handling for different chapters
    if (ruleIndex === 0) { // Kapitel 1
      if (paragraphs.length >= 4) {
        const firstPart = paragraphs.slice(0, 3).join('\n\n');
        const secondPart = paragraphs.slice(3).join('\n\n');
        return { firstPart, secondPart };
      }
    } else if (ruleIndex === 1) { // Kapitel 2 (1/3)
      if (paragraphs.length >= 3) {
        const firstPart = paragraphs.slice(0, 2).join('\n\n');
        const secondPart = paragraphs.slice(2).join('\n\n');
        return { firstPart, secondPart };
      }
    } else if (ruleIndex === 3) { // Kapitel 2 (3/3)
      if (paragraphs.length >= 2) {
        const firstPart = paragraphs.slice(0, 1).join('\n\n');
        const secondPart = paragraphs.slice(1).join('\n\n');
        return { firstPart, secondPart };
      }
    } else if (ruleIndex === 4) { // Kapitel 3 - Boss-huller
      // Split at "Boss-eksempler:"
      const bossIndex = text.indexOf('Boss-eksempler:');
      if (bossIndex !== -1) {
        const firstPart = text.substring(0, bossIndex).trim();
        const secondPart = text.substring(bossIndex).trim();
        return { firstPart, secondPart };
      }
    } else if (ruleIndex === 5) { // Kapitel 4 - Mini-discipliner
      // Keep all text on left side
      return { firstPart: text, secondPart: '' };
    }
    
    // Default fallback for other chapters
    if (paragraphs.length >= 4) {
      const firstPart = paragraphs.slice(0, 3).join('\n\n');
      const secondPart = paragraphs.slice(3).join('\n\n');
      return { firstPart, secondPart };
    } else {
      // Fallback to sentence splitting for shorter texts
      const sentences = text.split('. ');
      const midPoint = Math.ceil(sentences.length / 2);
      const firstPart = sentences.slice(0, midPoint).join('. ') + (midPoint < sentences.length ? '.' : '');
      const secondPart = sentences.slice(midPoint).join('. ');
      return { firstPart, secondPart };
    }
  };

  // Build pages array dynamically inside the component (after function definitions)
  const pages = [
    // Cover + Index spread
    {
      left: (
        <div>
          <div style={getTitleStyle()}>
            JULEGOLF 2025 REGELBOGEN
          </div>
        </div>
      ),
      right: (
        <div style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ fontWeight: 'bold', fontSize: '1.5rem', lineHeight: 1.1, textAlign: 'center', marginBottom: 18 }}>
            Indholds-<br />fortegnelse
          </div>
          <ol style={{ paddingLeft: 18, margin: 0 }}>
            {rules.map((rule, idx) => (
              <li key={rule.title}
                  style={{ marginBottom: 8, cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
                  onClick={e => { e.stopPropagation(); setPendingJump(idx); }}>
                {rule.title}
              </li>
            ))}
          </ol>
        </div>
      ),
    },
    // Rule pages (one rule per spread - text split between left and right)
    ...rules.map((rule, i) => {
      const { firstPart, secondPart } = splitText(rule.description, i);
      
      return {
        left: (
          <div style={{ 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center',
            textAlign: 'left',
            padding: '1em',
            position: 'relative'
          }}>
            <div style={{ 
              fontWeight: 'bold', 
              fontSize: windowWidth <= 480 ? '1rem' : '1.2rem', 
              marginBottom: 12,
              color: '#2c3e50',
              borderBottom: '2px solid #8B4513',
              paddingBottom: '8px',
              marginTop: '40px'
            }}>
              {rule.title}
            </div>
            <div style={{ 
              fontSize: windowWidth <= 480 ? '0.75rem' : '0.9rem',
              lineHeight: 1.5,
              whiteSpace: 'pre-line',
              overflowY: 'auto',
              flex: 1,
              paddingRight: '8px'
            }}>
              {firstPart}
            </div>
          </div>
        ),
        right: i === rules.length - 1 ? (
          // Show "thank you" page only if this is the last rule
          <div style={{ 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '2em',
            position: 'relative'
          }}>
            <div style={{ 
              fontSize: windowWidth <= 480 ? '1.2rem' : '1.5rem',
              fontWeight: 'bold',
              marginBottom: '1em',
              color: '#2c3e50'
            }}>
              Tak fordi du læste reglerne!
            </div>
            <div style={{ 
              fontSize: windowWidth <= 480 ? '1rem' : '1.2rem',
              color: '#7f8c8d'
            }}>
              God fornøjelse med JULEGOLF 2025! 🏆
            </div>
          </div>
        ) : (
          // Second part of the text for all rules except the last
          <div style={{ 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center',
            textAlign: 'left',
            padding: '1em',
            position: 'relative'
          }}>
            <div style={{ 
              fontSize: windowWidth <= 480 ? '0.75rem' : '0.9rem',
              lineHeight: 1.5,
              whiteSpace: 'pre-line',
              overflowY: 'auto',
              flex: 1,
              paddingRight: '8px',
              marginTop: '40px'
            }}>
              {secondPart}
            </div>
          </div>
        )
      };
    }),
  ];

  const maxSpread = pages.length - 1;

  // Handle index jump
  useEffect(() => {
    if (pendingJump !== null) {
      setSpread(getRuleSpread(pendingJump));
      setPendingJump(null);
    }
  }, [pendingJump]);

  // Replace dynamicPages with pages
  const leftPageContent = pages[spread].left || '';
  const rightPageContent = pages[spread].right || '';

  // Handler for clicking background to close book on any device (on any page)
  const handleBackgroundClick = (e) => {
    if (!open) return;
    if (e.target.classList.contains('rules-page-background')) {
      setOpen(false);
      setSpread(0);
      setShowChapterOverview(false);
    }
  };

  return (
    <div
      className={`rules-page-background ${open && windowWidth <= 768 ? 'mobile-landscape' : ''}`}
      onClick={handleBackgroundClick}
    >
      {/* Snow falling background */}
      <div className="snow-container-alt">
      </div>

      <div className={`rules-book-container ${open && windowWidth <= 768 ? 'mobile-landscape' : ''}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        {!open ? (
          <div
            className="rules-book-closed-cover"
            style={{
              width: getClosedBookDimensions(windowWidth).width,
              height: getClosedBookDimensions(windowWidth).height,
              margin: '0 auto',
              borderRadius: '8px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#fff',
              cursor: 'pointer',
              position: 'relative',
              transform: 'rotateY(-15deg) rotateZ(-1deg)',
              perspective: 1200,
              transition: 'transform 0.5s cubic-bezier(0.4,2,0.6,1), box-shadow 0.5s',
            }}
            onClick={handleOpen}
          >
            <img
              src="/loldisc.png"
              alt="Rules Book"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '8px',
              }}
            />
          </div>
        ) : (
          // Desktop view
          windowWidth > 768 ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              {/* Chapter Overview Sidebar */}
              <div style={{
                background: 'rgba(255,255,255,0.95)',
                borderRadius: '12px',
                padding: '30px',
                minWidth: '280px',
                maxWidth: '350px',
                maxHeight: '900px',
                overflowY: 'auto',
                boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                border: '2px solid #8B4513'
              }}>
                <h3 style={{ 
                  margin: '0 0 15px 0', 
                  color: '#2c3e50', 
                  fontSize: '1.5rem',
                  borderBottom: '2px solid #8B4513',
                  paddingBottom: '8px'
                }}>
                  Kapitler
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {rules.map((rule, idx) => (
                    <button
                      key={rule.title}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSpread(getRuleSpread(idx));
                      }}
                      style={{
                        background: spread === getRuleSpread(idx) ? '#e63946' : '#f8f9fa',
                        color: spread === getRuleSpread(idx) ? 'white' : '#2c3e50',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        cursor: 'pointer',
                        fontSize: '0.9rem',
                        textAlign: 'left',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        if (spread !== getRuleSpread(idx)) {
                          e.target.style.background = '#e9ecef';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (spread !== getRuleSpread(idx)) {
                          e.target.style.background = '#f8f9fa';
                        }
                      }}
                    >
                      {rule.title}
                    </button>
                  ))}
                </div>
              </div>

              {/* Desktop Book */}
              <div className="rules-book-open" style={{ width: getBookDimensions(windowWidth).width, height: getBookDimensions(windowWidth).height }}>
                <div className={`rules-book-pages${flipping ? ' flipping-' + flipping : ''}`}> 
                  <div
                    className={`rules-book-page rules-book-left${
                      (spread > 0 && flipping !== 'backward') ? ' flippable-left' : ''
                    }`}
                    onClick={() => handleFlip('backward')}
                    style={{ cursor: spread > 0 ? 'pointer' : 'default' }}
                  >
                    <div className={`rules-book-content${flipping === 'backward' ? ' flipping' : ''}`}>
                      {leftPageContent}
                    </div>
                  </div>
                  <div className="rules-book-spine"></div>
                  <div
                    className={`rules-book-page rules-book-right${
                      (spread < maxSpread && flipping !== 'forward') ? ' flippable-right' : ''
                    }`}
                    onClick={() => handleFlip('forward')}
                    style={{ cursor: spread < maxSpread ? 'pointer' : 'default' }}
                  >
                    <div className={`rules-book-content${flipping === 'forward' ? ' flipping' : ''}`}>
                      {rightPageContent}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // Mobile fullscreen view
            <div style={{ 
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              display: 'flex',
              flexDirection: 'row',
              zIndex: 9999
            }}>
              {/* Mobile Chapter Overview - 1/5 of screen */}
              <div style={{
                width: '20%',
                background: 'rgba(255,255,255,0.95)',
                padding: '15px',
                overflowY: 'auto',
                borderRight: '2px solid #8B4513'
              }}>
                <h3 style={{ 
                  margin: '0 0 10px 0', 
                  color: '#2c3e50', 
                  fontSize: '1rem',
                  borderBottom: '2px solid #8B4513',
                  paddingBottom: '5px'
                }}>
                  Kapitler
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  {rules.map((rule, idx) => (
                    <button
                      key={rule.title}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSpread(getRuleSpread(idx));
                      }}
                      style={{
                        background: spread === getRuleSpread(idx) ? '#e63946' : '#f8f9fa',
                        color: spread === getRuleSpread(idx) ? 'white' : '#2c3e50',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '6px 8px',
                        cursor: 'pointer',
                        fontSize: '0.7rem',
                        textAlign: 'left',
                        transition: 'all 0.2s'
                      }}
                    >
                      {rule.title}
                    </button>
                  ))}
                </div>
              </div>

              {/* Mobile Book - 4/5 of screen */}
              <div style={{
                width: '80%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
              }}>
                {/* Book container */}
                <div style={{
                  width: '90%',
                  height: '90%',
                  position: 'relative',
                  display: 'flex'
                }}>
                  {/* Left page (click to go back) */}
                  <div 
                    style={{
                      width: '50%',
                      height: '100%',
                      background: '#fff',
                      border: '1px solid #ddd',
                      borderRadius: '8px 0 0 8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: spread > 0 ? 'pointer' : 'default',
                      fontSize: '0.8rem',
                      padding: '10px',
                      overflowY: 'auto',
                      position: 'relative'
                    }}
                    onClick={() => handleFlip('backward')}
                  >
                    {leftPageContent}
                    {/* Flipped corner indicator for left page */}
                    {spread > 0 && (
                      <div style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '0',
                        height: '0',
                        borderStyle: 'solid',
                        borderWidth: '0 20px 20px 0',
                        borderColor: 'transparent #e63946 transparent transparent',
                        zIndex: 5
                      }} />
                    )}
                  </div>
                  
                  {/* Right page (click to go forward) */}
                  <div 
                    style={{
                      width: '50%',
                      height: '100%',
                      background: '#fff',
                      border: '1px solid #ddd',
                      borderRadius: '0 8px 8px 0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: spread < maxSpread ? 'pointer' : 'default',
                      fontSize: '0.8rem',
                      padding: '10px',
                      overflowY: 'auto',
                      position: 'relative'
                    }}
                    onClick={() => handleFlip('forward')}
                  >
                    {rightPageContent}
                    {/* Flipped corner indicator for right page */}
                    {spread < maxSpread && (
                      <div style={{
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        width: '0',
                        height: '0',
                        borderStyle: 'solid',
                        borderWidth: '0 0 20px 20px',
                        borderColor: 'transparent transparent #e63946 transparent',
                        zIndex: 5
                      }} />
                    )}
                  </div>
                </div>

                {/* Exit fullscreen button - shows when scrolling */}
                {showExitButton && (
                  <button
                    onClick={handleClose}
                    style={{
                      position: 'fixed',
                      bottom: '20px',
                      right: '20px',
                      background: 'rgba(230, 57, 70, 0.9)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '25px',
                      padding: '12px 20px',
                      fontSize: '0.9rem',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                      zIndex: 1000,
                      backdropFilter: 'blur(10px)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(183, 28, 28, 0.9)';
                      e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'rgba(230, 57, 70, 0.9)';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    Exit Fullscreen
                  </button>
                )}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default RulesBook; 